<template>
    <a class="iconContainer" :href="link" target="_blank">
        <i :class="`${icon} fa-2x icon`"></i>
    </a>
</template>

<script>
export default {
    name: 'SocialIcon',
    props: {
        icon: {
            type: String,
            required: true,
            default: "fas fa-exclamation-triangle"
        },
        link: {
            type: String,
            required: true,
            default: "http://casafile.ch"
        }
    }
}
</script>

<style lang="scss" scoped>
    $icon-size: 50px;
    .iconContainer {
        height: $icon-size;
        width: $icon-size;
        line-height: $icon-size;
        text-align:center;
        background-color: white;
        border-radius: calc(#{$icon-size} / 2);
        cursor: pointer;
        // margin: 10px;
    }
    .icon {
        color: $primary-color !important;
        line-height: inherit;
    }
</style>

